import { generateUnOrderedList, getCircleTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc53 = {
    title: "Image 53: Examples of child-care centres using nature integration principles.",
    para1: <>
        <p>This image shows an example of a child-care centre which has large windows on all sides which allows in natural lighting. The windows also show ample greenery on all sides facilitating integration of the natural greenery for the space. </p>
        <p>The child-care centre shows children playing around in the space with a caregiver. The centre also has a cupboard for storage and a camp bed.</p>
    </>
}

export const ImageDesc54 = {
    title: "Image 54: Example of positive usage of colours.",
    para1: "The image shows an example of a classroom which utilizes colours in a positive way. The tables, chairs and furniture in the room are a light wooden colour which brings a sense of nature into the room. The walls are a soothing yellow and other pops of colour in the room also make the room cheerful and soothing. "
}

export const ImageDesc55 = {
    title: "Image 55: Example of learning wall panel for sensory rooms",
    para1: "The image shows a girl playing with a wall panel while leaving on a bean bag, in a sensory room. The wall panel is in the shape of a crocodile which is green and has several different sensory games on it. The wall is blue in colour. "
}

export const ImageDesc56 = {
    title: "Image 56: Example of child protection seats.",
    para1: <>
        <p>The image shows a washroom that has been designed to accommodate parents with young children. The bathroom has a white, wall-mounted toilet with a flush above it. The flush has a signage next to it with “Kindly press in the centre” written in English and Hindi. A hand-held are faucet and a toilet paper dispenser are mounted on the wall next to the toilet.</p>
        <p>A child protection seat is on the wall next to the toilet paper dispenser which is grey in colour with a safety strap. A blue sign is placed on the wall above the seat with “Protection Seal” in English and Hindi lettering above it.</p>
    </>
}

export const ImageDesc57 = {
    title: "Image 57: Prototype design for a VWDC Waiting Area. ",
    para1: <>
        <p>The image shows a prototype design for a VWDC waiting area taken from the VWDC Guidelines. It is a floor plan of a rectangular waiting room, with two toilets. All spaces, furniture and fixtures within the space have been labelled on the prototype design. </p>
        <p>"WAITING 50X50M" is written in the center of the waiting room. This refers to the dimensions of the waiting room being 50 meters by 50 meters. The room has a three seater sofa and the labelling states that it is for the “Witness to lie down”. There is a table in front of the sofa set which has a microphone and headphones for the witness to use for video-conferencing. There is a table at the side and the labelling states that it is “Space for Water Bottle”. There are 360 Degree recording cameras in the waiting room which the labelling suggests should be placed in a place “as inconspicuous as possible”. The waiting room also has a carpet in one corner with “cushions for kids”. </p>
        <p>One of the toilets, which is a “universally accessible” toilet, has an entrance from within the waiting room. It has a WC and a wash basin.</p>
        <p>The second toilet next to it is also a “universally accessible” toilet. It has a WC and a wash basin as well. The entrance to this toilet is from an outside corridor. </p>
        <p>
            The labelling also states that there should be:
            <div className="figure_desc">
            {generateUnOrderedList([
                "No Paintings",
                "Simple Clean Walls",
                "Fan/AV/Heating",
                "Natural Daylight ",
                "1 or 2 Indoor Plants",
                "220-250 LUX",
                "Dust-free, Low Noise with UPUC",
                "All Windows with DGU",
            ])}
            </div>
        </p>
        <p>The labelling also states that the Waiting Room “must look like a home room not office room”.  </p>
    </>
}

export const FigureDesc44 = {
    title: "Figure 44: Representation of the Vulnerable Witness Deposition Complex and allied amenities.",
    para1: <>
        <p><span><b>Orientation of the floor plan: </b></span>
            The figure shows a 3D render of the various amenities present in the Vulnerable Witness Deposition Complex. The features are described space by space. This has been designed to be on the ground floor of a Court building.
        </p>
        <p>The features are being described space by space. </p>
      
            {getCircleTypeListItem([
                <>
                    Outdoor Play Area
                    <div className="figure_desc">
                    {generateUnOrderedList([
                        "The outdoor play area is at the bottom left corner of the floor plan. ",
                        "The play area has accessible instruments and features for children such as wall marimba, sandpit, wheelchair sandpit, spring rider and emperor chimes (musical instrument).",
                        "The play area also has drinking water provisions.",
                        "To the right of the play area is the entrance to the complex.",

                    ])}
                    </div>
                </>,
                <>
                    Entrance to the POCSO Complex
                    <div className="figure_desc">
                    {generateUnOrderedList([
                        "The entrance to the POCSO Complex has a ramp on the right and a staircase to the left with tactile pavers to be accessible to diverse user groups",
                        "The ramp leads to a landing where seating has been provided for two security guards. ",
                        "The landing also has potted plants to ensure that it is not intimidating.",
                        "The entrance leads to a lobby.",

                    ])}
                    </div>
                </>,
                <>
                    Lobby
                    <div className="figure_desc">
                    {generateUnOrderedList([
                        "The lobby is to the right of the play area as per the floor plan and behind the entrance.",
                        "A lobby has been provided so as to be an additional waiting area apart from the waiting area prescribed under VWDC.",
                        "The lobby has been provided with seating along with a provision for a wheelchair.",
                        "It also has a case display screen.",
                        "There are three doors leading out from the lobby -  to the POCSO Courtroom, counsellor’s room and public pantry.",
                    ])}
                    </div>
                </>,
                <>
                    Counsellor’s Room
                    <div className="figure_desc">
                    {generateUnOrderedList([
                        "The counsellor’s room has been provided with comfortable sofa set seating along with a table.",
                        "An office table has been provided for the counsellor with ergonomic chairs.",
                        "The table also has a computer.",
                        "A cupboard has been provided for storage facilities.",
                        "Drinking water provisions have been given.",
                    ])}
                    </div>
                </>,
                <>
                    Public Pantry
                    {getCircleTypeListItem([
                        "The public pantry has a platform ledge with storage below it. ",
                        "The storage is provided for keeping snack items.",
                        "The public pantry has a door to the left leading to the drinking water facilities and the accessible gender neutral washroom facilities.",
                        "The public pantry has a second door leading to the waiting room.",

                    ])}
                </>,
                <>
                    Washroom
                    {getCircleTypeListItem([
                        "The washroom has been provided with a wash basin, urinal and an Indian toilet. ",
                    ])}
                </>,
                <>
                    Waiting Room
                    {getCircleTypeListItem([
                        "The waiting room has a comfortable sofa set, a bean bag and additional floor seating. ",
                        "It has a sensory board.",
                        "It also has a case display screen and drinking water facilities.",
                        "Space has been given for a pantry area and it leads to an accessible, gender neutral washroom. ",
                        "The waiting room has two additional doors leading to the deposition room and a feeding room. ",

                    ])}
                </>,
                <>
                    Deposition Room
                    {getCircleTypeListItem([
                        "The deposition room has been provided with a comfortable sofa set seating.",
                        "The room has a screen and mic for the victim/witness to be able to give their deposition comfortably.",
                        "The room has a child play area with a sensory board.",
                        "Seating has been provided for a technician or Court clerk to use if necessary. "

                    ])}
                </>,
                <>
                    Feeding Room
                    {getCircleTypeListItem([
                        "The feeding room has been provided with a comfortable sofa with a table to keep necessities.",
                        "The room has storage facilities."

                    ])}
                </>,

            ], "a")}
       
        <p>The Courtroom design presented in the figure is the same as the design layout suggested for the POCSO Courtroom as described in Figure 40.</p>
    </>
}

